import { type NativeEmbedFeatureList } from '../types.ts';

/**
 * Merges both feature lists together. Only when both features are true
 * will a feature be true.
 */
export function mergeEnabledFeatures(
  localFeatures: NativeEmbedFeatureList,
  externalFeatures: NativeEmbedFeatureList,
): NativeEmbedFeatureList {
  const allKeys = [
    ...new Set([...Object.keys(localFeatures), ...Object.keys(externalFeatures)]),
  ];

  return allKeys.reduce((merged, k) => {
    const key = k as keyof NativeEmbedFeatureList;

    merged[key] = localFeatures[key] === true && externalFeatures[key] === true;

    return merged;
  }, {} as NativeEmbedFeatureList);
}
